<template>
	<header class="navbar navbar-default">
		<div class="container" style="margin-left:0px">
			<a href="#/" class="navbar-brand">
				<span style="color:black;">SISTEMA DE VOTAÇÃO ONLINE</span>
				<span style="color: tomato;">{{ env }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				<img src="../../../assets/img/logo_prefeitura.png" class="pull-left" alt="logo" style="height:50px;width:auto">
			</a>
			<v-logged-user :usuario="usuario" class="pull-right" />
		</div>
	</header>
</template>

<script>
	import VLoggedUser from '@/views/permisys/logged-user';

	export default {
		components: { VLoggedUser },

		data() {
			return {
				env: window.Config.ENV
			};
		},

		computed: {
			usuario() {
				return this.$store.state.usuario;
			}
		}
	};
</script>

<style scoped>
	header {
		margin: 0;
		border: 0;
		border-bottom: solid 1px #e7e7e7;
		border-radius: 0;
	}
	header img {
		width: 40px;
		margin: -10px 5px 0 0;
	}
</style>